var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button-group",
        { attrs: { size: "sm" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true },
                },
              ],
              attrs: {
                variant: "outline-info cursor-pointer",
                title: "Start video recording",
              },
              on: { click: _vm.startRecording },
            },
            [_c("b-icon", { attrs: { icon: "camera-reels" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true },
                },
              ],
              attrs: {
                variant: "outline-info cursor-pointer",
                title: "Start video and screen recording",
              },
              on: { click: _vm.startVideoAndScreenRecording },
            },
            [_c("b-icon", { attrs: { icon: "fullscreen" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true },
                },
              ],
              attrs: {
                variant: "outline-info cursor-pointer",
                title: "Start screen recording with audio only",
              },
              on: { click: _vm.startScreenRecording },
            },
            [_c("b-icon", { attrs: { icon: "display" } })],
            1
          ),
          _vm._v(" "),
          _vm.recording
            ? _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true },
                    },
                  ],
                  attrs: {
                    variant: "outline-danger cursor-pointer",
                    title: "Stop recording",
                  },
                  on: { click: _vm.stopRecording },
                },
                [_c("b-icon", { attrs: { icon: "stop-circle" } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.recordingUploading
            ? _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true },
                    },
                  ],
                  attrs: {
                    variant: "outline-info cursor-pointer",
                    title: "Uploading...",
                  },
                },
                [_c("b-spinner", { attrs: { small: "", label: "Spinning" } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: { hover: true },
            },
          ],
          attrs: {
            variant: "outline-info cursor-pointer",
            title: "Show recordings",
            size: "sm",
          },
          on: { click: _vm.handleShowRecordingsBtn },
        },
        [
          _vm.recordingsLoading
            ? _c("b-spinner", { attrs: { small: "", label: "Spinning" } })
            : _c("b-icon", { attrs: { icon: "folder" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.recording && _vm.showPreview,
              expression: "recording && showPreview",
            },
          ],
          staticClass: "video-preview mt-3",
        },
        [
          _c("video", {
            ref: "videoPreview",
            attrs: { autoplay: "", playsinline: "", muted: "" },
            domProps: { muted: true },
          }),
        ]
      ),
      _vm._v(" "),
      _c("canvas", {
        staticStyle: { display: "none" },
        attrs: { id: _vm.canvasId },
      }),
      _vm._v(" "),
      _c("RecordingsListModal", {
        attrs: {
          recordings: _vm.recordings,
          "current-page": _vm.currentPage,
          total: _vm.recordingsCount,
          "uploaded-video-file": _vm.uploadedVideoFileId,
        },
        on: {
          pageChanged: _vm.handlePageChanged,
          delete: _vm.handleDeletedBtn,
          close: _vm.handleRecordingsModalClose,
          changeName: _vm.handleChangeName,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }